(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tipset/assets/javascripts/models/share.js') >= 0) return;  svs.modules.push('/modules/tipset/assets/javascripts/models/share.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.tipset.models.Share = Backbone.Model.extend({
    initialize: function() {
      var drawId = svs.tipset.data.navigation.did,
        betsStr = svs.tipset.data.navigation.mid,
        betsNr = Array.from(betsStr),
        currentDraw = svs.tipset.collections.draws.getDrawById(
          parseInt(drawId, 10)
        );
      for (var i = 0; i < currentDraw.attributes.drawEvents.length; i++) {
        currentDraw.attributes.drawEvents[i].betButtons = betsNr[i];
      }

      this.set('regCloseTime', currentDraw.attributes.regCloseTime);
      this.set('week', currentDraw.attributes.week);
      this.set('drawEvents', currentDraw.attributes.drawEvents);
    }
  });
})(Backbone, _, svs);

 })(window);